__turbopack_context__.v({
  "basketItemTable": "basket-item-table-module-scss-module__H3lp8G__basketItemTable",
  "basketItemTable_hiddenBuy": "basket-item-table-module-scss-module__H3lp8G__basketItemTable_hiddenBuy",
  "bonuses": "basket-item-table-module-scss-module__H3lp8G__bonuses",
  "content": "basket-item-table-module-scss-module__H3lp8G__content",
  "countFieldWrap": "basket-item-table-module-scss-module__H3lp8G__countFieldWrap",
  "footer": "basket-item-table-module-scss-module__H3lp8G__footer",
  "imageCell": "basket-item-table-module-scss-module__H3lp8G__imageCell",
  "imageCellMobile": "basket-item-table-module-scss-module__H3lp8G__imageCellMobile",
  "imageLink": "basket-item-table-module-scss-module__H3lp8G__imageLink",
  "quantityCell": "basket-item-table-module-scss-module__H3lp8G__quantityCell",
  "removeCell": "basket-item-table-module-scss-module__H3lp8G__removeCell",
  "titleCell": "basket-item-table-module-scss-module__H3lp8G__titleCell",
  "titleLink": "basket-item-table-module-scss-module__H3lp8G__titleLink",
  "totalCell": "basket-item-table-module-scss-module__H3lp8G__totalCell",
});
